export class UpiPaymentDetails {

    transAmt: number;
    transDate: string;
    transStatus: string;
    customerCode: string;
    merchantTranId: string;
}
